<template>
  <div
    class="d-flex align-center"
    style="margin: 100px 0;"
  >
    <v-card
      class="auth-card mx-auto pa-4 mx-2"
    >
      <v-card-text>
        <v-form
          class="multi-col-validation"
          @submit.prevent="handleConfirmacaoCadastroFormSubmit"
        >
          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <p class="text-2xl font-weight-semibold text--primary">
                Confirmação de cadastro
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-hover v-slot="{ hover }">
                <v-btn
                  :color="hover ? '#25D366' : 'primary'"
                  type="submit"
                >
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="secondary"
                  />
                  <span v-else>Confirmar</span>
                </v-btn>
              </v-hover>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useRouter } from '@/@core/utils'
import useCentralStore from '@/store/central'
import ClienteService from '@/services/modules/ClienteService'

export default {
  setup() {
    const { requestUrl } = storeToRefs(useCentralStore())
    const { router } = useRouter()
    const loading = ref(false)

    async function handleConfirmacaoCadastroFormSubmit() {
      if (loading.value) return

      const { email } = router.currentRoute.query
      if (!email) {
        Vue.$toast.warning('Nenhum email informado.')
        return
      }

      try {
        loading.value = true
        await ClienteService.confirmarCadastro({ email, urlAlias: requestUrl.value })
      } finally {
        loading.value = false
      }
    }

    return {
      loading,
      handleConfirmacaoCadastroFormSubmit,
    }
  },
}
</script>
